import SeoPage from "./SeoPage";

export default function ReduceVideoQuality() {
    return (
        <SeoPage
            heading="Reduce Video Size Without Losing Quality"
            intro="Reduce video file size while maintaining visual quality using TinyCompression’s optimized compression engine."
            title="Reduce Video Size Without Losing Quality – TinyCompression"
            description="Reduce video size without losing quality using TinyCompression. Free online tool with custom quality control and instant download."
        />
    );
}
